export const CALENDAR_GRID_AGENDA_SKELETON_DAYS_LENGTH = 3

export const CALENDAR_GRID_AGENDA_SKELETON_ROWS_LENGTH = 2
